module.exports = __webpack_public_path__ + "img/apps-original.65df165d.png";